"use client"
import { motion, AnimatePresence } from "framer-motion"
import InicioSection from "./sections/InicioSection"
import NosotrosSection from "./sections/NosotrosSection"
import BeneficiosSection from "./sections/BeneficiosSection"
import ServiciosSection from "./sections/ServiciosSection"
import ContactanosSection from "./sections/ContactanosSection"
import DescargarSection from "./sections/DescargarSection"

export default function MainContent({ seccion, handleNavClick, onThemeChange }) {
  return (
    <main className="main-content-ini">
      <AnimatePresence mode="wait">
        <motion.div
          key={seccion}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.4 }}
          className="seccion-contenido-ini"
        >
          {seccion === "inicio" && <InicioSection handleNavClick={handleNavClick} onThemeChange={onThemeChange} />}
          {seccion === "nosotros" && <NosotrosSection />}
          {seccion === "beneficios" && <BeneficiosSection />}
          {seccion === "servicios" && <ServiciosSection />}
          {seccion === "descargar" && <DescargarSection />}
          {seccion === "contactanos" && <ContactanosSection />}
        </motion.div>
      </AnimatePresence>
    </main>
  )
}
